import { API_URLS } from '../utils/Constants';
import Cookies from 'universal-cookie';
import axios from 'axios';

export const signupApi = ({ request, source }) => {
  const url = API_URLS.SIGN_UP;

  let data = JSON.stringify(request.data);

  let config = {
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: source.token,
    data: data,
  };

  return axios.request(config);
};

export const signinApi = ({ request, source }) => {
  const url = API_URLS.SIGN_IN;

  let data = JSON.stringify(request.data);

  let config = {
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: source.token,
    data: data,
  };

  return axios.request(config);
};

export const updateAccountApi = ({ request, source }) => {
  const url = API_URLS.UPDATE_ACCOUNT;
  let data = JSON.stringify(request.data);
  const cookies = new Cookies();
  const token = cookies.get('token');

  let config = {
    method: 'patch',
    maxBodyLength: Infinity,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: data,
    cancelToken: source.token,
  };

  return axios.request(config);
};

export const updateAccountPasswordApi = ({ request, source }) => {
  const url = API_URLS.UPDATE_PASSWORD;
  let data = JSON.stringify(request.data);
  const cookies = new Cookies();
  const token = cookies.get('token');

  let config = {
    method: 'patch',
    maxBodyLength: Infinity,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: data,
    cancelToken: source.token,
  };

  return axios.request(config);
};

export const myDatasetsApi = ({ request, source }) => {
  const url = API_URLS.MY_DATASETS;

  const cookies = new Cookies();
  const token = cookies.get('token');

  let params = request.params;

  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: params,
    cancelToken: source.token,
  };

  return axios.request(config);
};

export const deActivateAccountApi = ({ request, source }) => {
  const url = API_URLS.DEACTIVATE_ACCOUNT;

  const cookies = new Cookies();
  const token = cookies.get('token');

  let params = request.params;

  let config = {
    method: 'patch',
    maxBodyLength: Infinity,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: params,
    cancelToken: source.token,
  };

  return axios.request(config);
};

export const vendorApi = ({ request, method, source }) => {
  const url = API_URLS.VENDOR;

  const cookies = new Cookies();
  const token = cookies.get('token');

  let config = {
    method: method,
    maxBodyLength: Infinity,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: request.params,
    data: request.data,
    cancelToken: source.token,
  };

  return axios.request(config);
};
